import { r as registerInstance, h, e as Host, g as getElement } from './index-6c727dca.js';
import './component-errors-b6f1109b.js';
import { k as klassList } from './utils-c16d9285.js';

const epiInputCss = ":host{position:relative;display:-ms-flexbox;display:flex;-ms-flex-flow:column nowrap;flex-flow:column nowrap;font-size:16px}::slotted(.epi-input__control){height:44px;border:1px solid var(--black_s40);border-radius:4px;font-size:16px;text-indent:15px}::slotted(.epi-input__control:focus){border-color:var(--brandPrimary)}::slotted(.is--invalid){border-color:var(--brandWarn)}::slotted(.epi-input__control:disabled){background:var(--white);border-color:var(--black_s20)}.epi-input__label.is--invalid{color:var(--brandWarn)}.epi-input__label.is--disabled{color:var(--black_s20)}";

const EpiInput = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.klassName = `epi-input`;
    /** Whether or not the input is disabled */
    this.disabled = false;
    /** Whether or not the input is invalid */
    this.invalid = false;
  }
  handleDisabledChange(newValue, oldValue) {
    if (newValue !== oldValue) {
      if (this.inputEl) {
        this.inputEl.disabled = newValue;
      }
    }
  }
  handleInvalidChange(newValue, oldValue) {
    if (newValue !== oldValue) {
      if (this.inputEl) {
        newValue
          ? this.inputEl.classList.add(`is--invalid`)
          : this.inputEl.classList.remove(`is--invalid`);
      }
    }
  }
  /**
   * Lifecycle hooks in the order that they are called. Uncomment to use
  */
  // componentWillLoad() { }
  // componentDidLoad() { }
  // componentWillRender () { }
  componentDidRender() {
    this.inputEl = this.el.querySelector(`input`);
    if (this.inputEl) {
      // debugger;
      this.inputEl.disabled = this.disabled;
      this.handleInvalidChange(this.invalid);
      this.inputEl.classList.add(`${this.klassName}__control`);
      this.inputEl.id = this.inputId;
    }
  }
  // componentWillUpdate() { }
  // componentDidUpdate() { }
  /**
   * The render() function should always be the last one in the class
  */
  render() {
    return (h(Host, { class: this.klassName }, h("epi-label", { class: klassList(`${this.klassName}__label`, this.invalid && `is--invalid`, this.disabled && `is--disabled`), for: this.inputId }, h("slot", { name: "label" })), h("slot", { name: "epiInput" }), h("slot", null)));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "disabled": ["handleDisabledChange"],
    "invalid": ["handleInvalidChange"]
  }; }
};
EpiInput.style = epiInputCss;

export { EpiInput as epi_input };
